<template>
  <div class="cetrtosolci">
    <h1>Spoštovani starši {{ cleanedRouteName }}!</h1>
    <p>
      Na šoli smo že začeli s pripravami na novo šolsko leto. Nekaj podatkov, ki jih potrebujemo za pravočasno organizacijo dela, lahko pridobimo le z vašim sodelovanjem, zato vas prosimo, da odgovorite na spodnja vprašanja, ki se nanašajo na šolsko leto 2020/2021.
      <br />
      <br />Prosimo vas, da svojo odločitev dobro premislite, saj je podlaga za organizacijsko in kadrovsko postavitev dela, kar pomeni, da kasnejše spremembe ne bodo možne.
    </p>
    <div class="obrazec">
      <h3>
        Izpolnite obrazec
        <i>(vsa polja so obvezna)</i>
      </h3>
      <hr />
      <Form v-bind:formId="routeId"></Form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Form from "@/components/Form.vue";

export default {
  name: "Anketa",
  components: {
    Form
  },

  data() {
    return {
      routeName: this.$route.name,
      routeId: this.$route.params.id
    }
  },

  computed: {
    cleanedRouteName: function() {
      return this.routeId.replace("lci", "lcev");
    }
  },

  mounted() {
    console.log(this.$route.name);
    console.log(this.$route.params.id);
  }
};
</script>

<style lang="less" scoped>
.cetrtosolci {
  width: 80%;
  margin: 0 auto;
  background-color: white;
  padding: 30px 40px;
  box-shadow: 0px 10px 50px rgb(184, 165, 124);
  text-align: left;

  h1 {
    margin-bottom: 20px;
    text-align: center;
  }

  & > p:first-of-type {
    width: 800px;
    margin: 0 auto;
    line-height: 1.6;

    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  }

  hr {
    margin-bottom: 30px;
  }
}

.obrazec {
  width: 800px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 40px;

  @media screen and (max-width: 1024px) {
      width: 100%;
  }

  h3 {
    text-align: left;
    margin-bottom: 0;
  }
}
</style>